import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store, { persistor } from '@/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Crisp from 'crisp-sdk-web';
import App from './App';
import '@shopify/polaris/build/esm/styles.css';
import '@shopify/polaris-viz/build/esm/styles.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { Page } from '@shopify/polaris';

function ErrorFallback({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => { }}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<Page />}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </Suspense>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </I18nextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals((e) => {
//   if (e.name === 'FCP') {
//     if (e.value > 1800) {
//       document.location.reload();
//     }
//   }
// });
reportWebVitals((e) => {
  if (e.name === 'FCP') {
    let reloadCount = parseInt(localStorage.getItem('reloadCount') || '0', 2);
    if (e.value > 1700 && reloadCount < 2) {
      reloadCount += 1;
      localStorage.setItem('reloadCount', reloadCount.toString());
      document.location.reload();
    } else if (e.value <= 1700) {
      localStorage.setItem('reloadCount', '0');
    }
  }
});